export default "__VITE_ASSET__d3ee81be__"